import React, { useState, Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
const NewsletterEditDelete = React.lazy(() => import('./NewsDelete.component'));
const NewsletterEmail = React.lazy(() => import('./NewsSendEmail.component'));
import { GreySection } from '../EditUser/EditUserPage/EditUser.styles';
import NewsletterInputs from '../../../Components/NewsletterForm/NewsletterInputs.component';
const NewsletterSampleEmail = React.lazy(
  () => import('./NewsSampleEmail.component')
);
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../CreateRoutes/CreateForm.styles';
const NewsletterEditSubmit = React.lazy(() => import('./NewsSubmit.component'));

const NewsletterEditInnerComponent = ({ newsletter, id }) => {
  const [news, setNews] = useState([]);
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (newsletter) {
      setNews(newsletter);
    }
  }, [newsletter]);
  return (
    <>
      <h2>Edit Newsletter</h2>
      <GreySection>
        {news?.sentOut ? (
          <p className="italicSpan">Newsletter has been sent out</p>
        ) : (
          <p className="italicSpan">Newsletter has not been sent out</p>
        )}
      </GreySection>
      <form>
        <Suspense fallback={<p>Loading newsletter inputs...</p>}>
          <NewsletterInputs news={news} setNews={setNews} />
        </Suspense>
      </form>

      <SubmitContainer>
        <TopSubmit>
          {status.length > 0 && <p className="result">{status}</p>}
        </TopSubmit>
        <BottomSubmit>
          <Suspense fallback={<p>Loading delete button...</p>}>
            <NewsletterEditDelete id={id} setStatus={setStatus} />
          </Suspense>
          <Suspense fallback={<p>Loading send email button...</p>}>
            <NewsletterEmail id={id} setStatus={setStatus} />
          </Suspense>
          <Suspense fallback={<p>Loading sample email button...</p>}>
            <NewsletterSampleEmail id={id} setStatus={setStatus} />
          </Suspense>
          <Suspense fallback={<p>Loading submit button...</p>}>
            <NewsletterEditSubmit
              id={id}
              newsletter={news}
              setStatus={setStatus}
            />
          </Suspense>
        </BottomSubmit>
      </SubmitContainer>
    </>
  );
};
NewsletterEditInnerComponent.propTypes = {
  newsletter: PropTypes.object,
  id: PropTypes.string,
};
export default NewsletterEditInnerComponent;
